// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon img[data-v-56f641c9]{width:.64rem;height:.64rem}", ""]);
// Exports
module.exports = exports;
